module.exports = __webpack_public_path__ + "assets/icons/tutorial.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/sidemenu/tutorial.png
// module id = ./src/styles/icons/sidemenu/tutorial.png
// module chunks = 0